export default __webpack_public_path__ + "static/media/connection-visibility-set-off.d5728f65.svg";